/**
 * Fee painted on one funding-picker row.
 *
 * The highlight (pinned instrument or cash) follows the footer once a binding
 * quote exists; while the composed SKU is known but the quote is still loading
 * it uses that option's customerFee. Every other row stays on the method
 * estimate — never inherit the quote (sibling cards, add CTAs, other methods).
 */
export function resolvePickerRowFee(input: {
  isHighlight: boolean;
  hasQuote: boolean;
  quoteFee?: number | null;
  composedOptionFee?: number | null;
  methodEstimateFee?: number | null;
}): number | null {
  if (input.isHighlight) {
    if (input.hasQuote) {
      return input.quoteFee ?? 0;
    }
    if (input.composedOptionFee != null) {
      return input.composedOptionFee;
    }
  }
  return input.methodEstimateFee ?? null;
}

/** Binding copy only when the highlight row has a matching quote. */
export function pickerRowFeeI18nKey(input: {
  isHighlight: boolean;
  hasQuote: boolean;
}): "payment.fee" | "payment.feeEstimated" {
  return input.isHighlight && input.hasQuote
    ? "payment.fee"
    : "payment.feeEstimated";
}
